import { Colors } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { AddToGroupsButton } from './addToGroupsButton';
import { CopyRoutinesToWorkspace } from './copyRoutinesToWorkspace';
import { DownloadRoutineWithDateFilter } from './downloadRoutineWithDateFilter';

export type Props = {
  routineIds: string[];
  workspaceId: string;
};

export const RoutineRowActions = ({ routineIds, workspaceId }: Props) => {
  const { t } = useTranslation();

  const count = routineIds?.length ?? 0;

  const selectedLabel =
    count !== 1
      ? t('routine.rowHeader.routinesSelected', {
          count: count,
        })
      : t('routine.rowHeader.routineSelected');

  return (
    count > 0 && (
      <View style={styles.container}>
        <Text style={styles.selectedLabel}>{selectedLabel}</Text>
        <View style={styles.btnGroup}>
          <AddToGroupsButton
            routineIds={routineIds}
            workspaceId={workspaceId}
          />
          <DownloadRoutineWithDateFilter
            label={t('routines.menu.download')}
            routineIds={routineIds}
            workspaceId={workspaceId}
          />
          <CopyRoutinesToWorkspace
            routineIds={routineIds}
            workspaceId={workspaceId}
          />
        </View>
      </View>
    )
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    marginLeft: 24,
    alignItems: 'center',
    gap: 12,
    paddingVertical: 4,
  },
  selectedLabel: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.primaryDark,
    alignSelf: 'center',
    marginRight: 8,
  },
  btnGroup: {
    flexDirection: 'row',
    gap: 8,
  },
});
